// @flow
import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const viewAddressesPromise = import("./ViewAddresses");
export default Auth(lazy(() => viewAddressesPromise));